export const Svg_076 = () => (
  <svg width={70} height={70} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
    <defs>
      <linearGradient
        id="a"
        x1={50.6}
        x2={42.8}
        y1={46.9}
        y2={58.1}
        data-name="Gradiente sem nome"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={44.8}
        x2={19.2}
        y1={9.2}
        y2={45.8}
        data-name="Gradiente sem nome 2"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={47.3}
        x2={44.6}
        y1={13}
        y2={16.9}
        data-name="Gradiente sem nome 3"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={33.4}
        x2={26.7}
        y1={10.2}
        y2={19.7}
        data-name="Gradiente sem nome 4"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
    </defs>
    <path
      d="M46.7 25.5c8.9-.3 8.9-13.2 0-13.5-8.9.3-8.9 13.2 0 13.5Zm0-9.6c3.7 0 3.7 5.6 0 5.7-3.7 0-3.7-5.6 0-5.7Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="m62.2 47.5-9.3-14.3c-2.1-3.5-7.6-3.5-9.7 0l-.9 1.5-8.1-12.4c-2.1-3.5-7.6-3.5-9.7 0l-6.8 10.4s0 .1-.1.2L8.1 47.5c-.4.6-.4 1.4 0 2 .3.6 1 1 1.7 1h51c1.5 0 2.5-1.8 1.6-3Zm-49-.9 6.4-9.9.1-.1 7.9-12.1c.7-1.1 2.5-1.1 3.2 0L38.9 37c1.3 2.3 5.1 2.3 6.5 0l1-1.5c.7-1.1 2.5-1.1 3.1 0l7.3 11.2H13.1Z"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M46.7 54.3h-1.5c-1.1 0-2 .9-2 2s.9 2 2 2h1.5c2.6 0 2.6-3.9 0-3.9Z"
      style={{
        fill: "url(#c)",
      }}
    />
    <path
      d="M36.7 54.3H23.4c-2.6 0-2.6 3.9 0 3.9h13.3c2.6 0 2.6-3.9 0-3.9Z"
      style={{
        fill: "url(#d)",
      }}
    />
  </svg>
)